<section class="ipm-dsb">
    <div class="ipm-dsb-glow"></div>
    <div class="ipm-dsb-rangoli ipm-dsb-rangoli-left"></div>
    <div class="ipm-dsb-rangoli ipm-dsb-rangoli-right"></div>
    <div class="ipm-dsb-orbs" aria-hidden="true">
        <span class="ipm-dsb-orb" *ngFor="let orb of orbs; trackBy: trackByIndex"
            [style.left.%]="orb.x" [style.top.%]="orb.y" [style.width.px]="orb.size" [style.height.px]="orb.size"
            [style.background]="'radial-gradient(circle, rgba(' + orb.color + ',.55) 0%, rgba(' + orb.color + ',.15) 50%, transparent 72%)'"
            [style.animation-duration.s]="orb.duration" [style.animation-delay.s]="orb.delay"></span>
    </div>
    <div class="ipm-dsb-diyas" aria-hidden="true">
        <div class="ipm-dsb-diya" *ngFor="let left of diyaPositions; trackBy: trackByIndex" [style.left]="left">
            <span class="ipm-dsb-diya-glow"></span>
            <span class="ipm-dsb-flame"></span>
            <span class="ipm-dsb-bowl"></span>
        </div>
    </div>
    <div class="ipm-dsb-line"></div>

    <div class="ipm-dsb-content">
        <div class="ipm-dsb-eyebrow">
            <span class="ipm-dsb-eyebrow-line"></span>
            <span>{{eyebrow}}</span>
            <span class="ipm-dsb-eyebrow-line ipm-dsb-eyebrow-line-right"></span>
        </div>

        <div class="ipm-dsb-title-row">
            <span class="ipm-dsb-emoji">🪔</span>
            <h2 class="ipm-dsb-title">
                <span class="ipm-dsb-violet">BEAT22</span>
                <span class="ipm-dsb-orange">DIWALI</span>
                <span class="ipm-dsb-violet">SALE</span>
            </h2>
            <span class="ipm-dsb-emoji">✨</span>
        </div>
         <div class="ipm-dsb-pills">
            <div class="ipm-dsb-pill ipm-dsb-pill-orange">
                <span class="ipm-dsb-pill-icon">🔥</span>
                <span>Up to <strong>{{beatOffer}}</strong> on Beats</span>
            </div>
            <!-- clickable once the sale is live: opens the Diwali Pro popup (handled by the parent) -->
            <div class="ipm-dsb-pill ipm-dsb-pill-purple" *ngIf="showPlanOffer"
                [class.is-clickable]="planOfferClickable"
                [attr.role]="planOfferClickable ? 'button' : null"
                [attr.tabindex]="planOfferClickable ? 0 : null"
                (click)="onPlanOfferClick()" (keydown.enter)="onPlanOfferClick()">
                <span class="ipm-dsb-pill-icon">⭐</span>
                <span><strong>{{planOffer}}</strong> on Pro Annual Plan</span>
                <span class="ipm-dsb-pill-arrow" *ngIf="planOfferClickable">→</span>
            </div>
        </div>
        <!-- button and sale countdown side by side (stacked on narrow screens) -->
        <div class="ipm-dsb-actions">
            <!-- enrolled (any beat on sale): green + Diwali gold button -->
            <div class="ipm-dsb-cta-wrap">
                <span class="ipm-dsb-cta-pulse" [class.is-enrolled]="enrolled"></span>
                <a class="ipm-dsb-cta" [class.is-enrolled]="enrolled" [routerLink]="ctaLink">{{ enrolled ? 'Enrolled ✓' : ctaLabel }} <span>→</span></a>
            </div>
            <!-- sale countdown on one line: "Sale starts in" before the sale, "Sale ends in" during it, hidden after -->
            <ipm-sale-countdown class="ipm-dsb-countdown" appearance="inline" *ngIf="startAt && endAt"
                [startAt]="startAt" [endAt]="endAt"></ipm-sale-countdown>
        </div>
    </div>
</section>
